export default "__VITE_ASSET__whhzCLcb__"